import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "error-msg ep-save" }
const _hoisted_3 = { class: "ep-save-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Discard your changes?", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "You have unsaved changes. If you leave now, they're lost.", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('keep')))
        }, "Keep editing"),
        _createElementVNode("button", {
          type: "button",
          class: "btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('discard')))
        }, "Discard changes")
      ])
    ])
  ]))
}